import styled, { css } from "styled-components";

export const Button = styled.button`
  appearance: none;
  border-radius: 2px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  padding: 4px 7px;
  text-transform: uppercase;
  transition: 0.2s all;

  ${({ theme }) => {
    if (theme === "apply") {
      return css`
        background-color: #e9e9ff;
        color: #1e22ff;
      `;
    }

    if (theme === "remove") {
      return css`
        background-color: #999;
        color: white;
      `;
    }
  }}

  :active {
    background-color: white;
  }
`;

export const CouponInput = styled.div`
  position: relative;

  div label {
    cursor: pointer;
  }

  &:hover {
    color: #1e22ff;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      input,
      button {
        opacity: 0.5;
        pointer-events: none;
      }
    `}

  ${Button} {
    position: absolute;
    top: 50%;
    right: 6px;
    z-index: 2;
  }
`;

export const CouponApplied = styled.div`
  position: relative;
  margin-top: 10px;

  > p {
    background-color: #ccc;
    border-radius: 4px;
    padding: 10px;
  }

  ${Button} {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
  }
`;
